import React, {useCallback, useState} from 'react';

import Button from '@pb/kit-component-button';
import {DialogFooter, DialogHeader, DialogMain} from '@pb/kit-component-dialog-v2';
import {Group} from '@pb/kit-component-group';
import {Message} from '@pb/kit-component-message';

import {useRemoveMicrosite} from './useRemoveMicrosite';

type Props = {
    accountId: number,
    onSuccess: () => void,
    onClose: () => void,
};

export const RemoveMicrositeModal = ({accountId, onClose, onSuccess}: Props) => {
    const [errorMessage, setErrorMessage] = useState('');
    const {busy, event} = useRemoveMicrosite({accountId, onSuccess, onFail: setErrorMessage});

    const removeMicrosite = useCallback(() => {
        event();
    }, [event]);

    return (
        <>
            <DialogHeader onClose={onClose}>
                Delete Microsite
            </DialogHeader>
            <DialogMain style={{padding: 24}}>
                {errorMessage ? <Message color="error">{errorMessage}</Message> : null}
                Are you sure you want to delete the Microsite and all its configurations? This action cannot be undone.
            </DialogMain>
            <DialogFooter>
                <Group>
                    <Button busy={busy} variant="Type.PRIMARY" onClick={removeMicrosite}>
                        Delete
                    </Button>
                    <Button variant="Type.SECONDARY" onClick={onClose}>
                        Cancel
                    </Button>
                </Group>
            </DialogFooter>
        </>
    );
};
